export const QueryGenerator = async (inputParams) => {
  let query = "";

  Object.keys(inputParams).map((key, i) => {
    if (inputParams[key] && query.length === 0) {
      query += `?${key}=${inputParams[key]}`;
    } else if (inputParams[key]) {
      query += `&${key}=${inputParams[key]}`;
    }
  });
  return query;
};
